import { createBrowserRouter } from 'react-router-dom'
import { AuthWrapper } from 'components/layout/AuthWrapper/AuthWrapper'
import { Invitation } from 'pages/auth/Invitation/Invitation'
import { routes } from 'shared/constants/routes'

export const invitationRouter = createBrowserRouter([
  {
    path: '/',
    element: <AuthWrapper />,
    children: [
      {
        path: routes.INVITATION,
        element: <Invitation />
      },
      {
        path: routes.ADMIN_INVITATION,
        element: <Invitation kind='admin' />
      }
    ]
  }
])
